import React from 'react';
import {
  Box,
  StepGroup,
  StepItem,
  StepItemIcon,
  StepItemIndicator,
  CheckCircleIcon,
} from '@razorpay/blade/components';
import useReduxSelector from 'utils/useReduxSelector';
import { OrgLogoImage } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/components/OrgLogoImage';
import { steps } from 'components/EmployeeOnboarding/ContractorSelfOnboarding/constants';
import payrollLogo from 'assets/payroll-logo.svg';
import {
  getStepProgress,
  getStepMarker,
  StepMarkerType,
} from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/utils';
import { useWizardInfo } from 'components/WizardViews/providers/WizardInfoProvider';

const renderMarker = (markerConfig: StepMarkerType): React.ReactElement => {
  if (markerConfig.type === 'icon') {
    return <StepItemIcon icon={CheckCircleIcon} color={markerConfig.color} />;
  }
  return <StepItemIndicator color={markerConfig.color} />;
};

export const OnboardingSidebar = (): React.ReactElement => {
  const { currentStep } = useWizardInfo();
  const organizationLogo = useReduxSelector(
    (state) => state.loggedInUser.data?.currentOrganization?.logo,
  );
  const hasOrgLogo = Boolean(organizationLogo);

  return (
    <Box display="flex" flexDirection="column" height="100%" justifyContent="space-between">
      <Box>
        <Box marginBottom="spacing.8">
          {hasOrgLogo ? (
            <OrgLogoImage />
          ) : (
            <img
              src={payrollLogo}
              alt="RazorpayX Payroll"
              style={{ maxHeight: '50px', maxWidth: '200px' }}
            />
          )}
        </Box>
        <Box>
          <StepGroup orientation="vertical" size="medium">
            {steps.map((stepData) => (
              <StepItem
                key={stepData.id}
                title={stepData.title}
                stepProgress={getStepProgress(currentStep, stepData.step)}
                marker={renderMarker(getStepMarker(currentStep, stepData.step))}
                isSelected={stepData.step === currentStep}
                isDisabled={stepData.step > currentStep}
              />
            ))}
          </StepGroup>
        </Box>
      </Box>
      {hasOrgLogo && (
        <Box marginTop="spacing.8">
          <img
            src={payrollLogo}
            alt="RazorpayX Payroll"
            style={{ height: '20px', width: 'auto', maxWidth: '160px' }}
          />
        </Box>
      )}
    </Box>
  );
};
